'use client';

import { useEffect, useMemo } from 'react';

import { ReadonlyURLSearchParams, usePathname, useSearchParams } from 'next/navigation';
import { useSilentRouter } from '@shared/hooks/use-router';
import { FormCards } from '@/features/home-page/components';

import { MIXPANEL_APP_FEATURES, mixpanelEvents } from '@/shared/constants/mixpanel-events';
import { emitMixpanelEvent } from '@/shared/utils/mixpanel-utils';

import { areURLSearchParamsEqual, getValidHomeSearchParams } from '@/utils/common';
import { HOME_PAGE_TAB_SEARCH_PARAM_KEY } from '@/utils/constants';

import { FormDashboardProvider } from '../common/form-dashboard-provider';
import FormDashboardHeader from '../views/form-dashboard-header';

function HomePage() {
	const searchParams = useSearchParams();
	const pathname = usePathname();
	const router = useSilentRouter();

	// Extracting valid search parameters
	const updatedSearchParamsState = useMemo(() => {
		const searchParamsToUpdate = getValidHomeSearchParams(
			searchParams ?? (new URLSearchParams() as ReadonlyURLSearchParams)
		);

		return {
			searchParamsToUpdate,
			areURLSearchParamsValid: areURLSearchParamsEqual(
				searchParams ?? (new URLSearchParams() as ReadonlyURLSearchParams),
				searchParamsToUpdate
			),
		};
	}, [searchParams]);

	const tabParamValue = decodeURIComponent(
		updatedSearchParamsState.searchParamsToUpdate.get(HOME_PAGE_TAB_SEARCH_PARAM_KEY) || ''
	);

	// const handleTabChange = useCallback(
	// 	(tabValue: string) => {
	// 		const searchParamsToUpdate = new URLSearchParams(
	// 			updatedSearchParamsState.searchParamsToUpdate.toString()
	// 		);

	// 		searchParamsToUpdate.set(HOME_PAGE_TAB_SEARCH_PARAM_KEY, encodeURIComponent(tabValue));
	// 		router.replace(`${pathname}?${searchParamsToUpdate.toString()}`);
	// 	},
	// 	[pathname, router, updatedSearchParamsState]
	// );

	useEffect(() => {
		if (!updatedSearchParamsState.areURLSearchParamsValid) {
			router.replace(`${pathname}?${updatedSearchParamsState.searchParamsToUpdate.toString()}`);
			return;
		}
	}, [updatedSearchParamsState, pathname, router]);

	useEffect(() => {
		emitMixpanelEvent(mixpanelEvents.VIEWED_DASHBOARD_PAGE, {
			feature: MIXPANEL_APP_FEATURES.DASHBOARD,
		});
	}, []);

	return (
		<FormDashboardProvider>
			<div className="h-full w-full overflow-y-auto px-0 focus-within:outline-none md:px-0">
				<div className="ml-auto mr-auto flex h-[100%] w-[100%] max-w-[760px] flex-1 flex-col">
					<FormDashboardHeader />

					<FormCards tabParamValue={tabParamValue} />
				</div>
			</div>
		</FormDashboardProvider>
	);
}

export default HomePage;
